<template>
  <div class="home">
    <site-header />
    <site-navigation id="home" />
    <!-- 轮播图区域 -->
    <div class="banner">
      <el-carousel height="780px">
        <el-carousel-item v-for="(item, i) in bannerList" :key="i">
          <div class="banner-item" @click="jumpUrl(item)">
            <img :src="item.image" alt="banner" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="main-content">
      <!-- 新增：新闻展示区域 -->
      <div class="news-showcase">
        <div class="news-carousel">
          <el-carousel height="350px">
            <el-carousel-item v-for="(item, i) in hotList" :key="i">
              <div class="carousel-item" @click="jump(item)">
                <img :src="item.image" alt="news" />
                <div class="carousel-content">
                  <h3 class="ellipsis">{{ item.title }}</h3>
                  <p class="ellipsis">{{ item.excerpt }}</p>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="news-tabs">
          <el-tabs>
            <el-tab-pane label="新闻快讯">
              <router-link
                class="news-more"
                to="/column/academy_news_information"
                >+更多</router-link
              >
              <!-- <span class="news-more">+更多</span> -->
              <ul class="news-list-tab">
                <li
                  v-for="item in newsList"
                  class="ellipsis"
                  :key="item.id"
                  @click="jump(item)"
                >
                  <span class="news-title">{{ item.title }}</span>
                  <span class="news-date">{{ item.displayDate }}</span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="研讨交流">
              <router-link
                class="news-more"
                to="/column/academy_news_communication"
                >+更多</router-link
              >
              <ul class="news-list-tab">
                <li
                  class="ellipsis"
                  v-for="item in noticeList"
                  :key="item.id"
                  @click="jump(item)"
                >
                  <span class="news-title">{{ item.title }}</span>
                  <span class="news-date">{{ item.displayDate }}</span>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <!-- 科研项目 -->
      <!-- <div class="news-section">
        <div class="section-header">
          <h2 style="color: #193d65; font-size: 24px; font-weight: bold">
            科研项目
          </h2>
          <router-link to="/column/academy_innovation_project" class="more-link"
            >+更多</router-link
          >
        </div>
        <div class="news-list">
          <div
            v-for="(item, i) in projectList"
            :key="i"
            class="news-item"
            @click="jump(item)"
          >
            <div class="news-date">
              <span class="day">{{ item.displayD }}</span>
              <span class="month">{{ item.displayM }}</span>
            </div>
            <div class="news-info">
              <h3>{{ item.title }}</h3>
              <p>{{ item.excerpt }}</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <site-footer />
  </div>
</template>

<script>
import SiteHeader from "@/components/layout/Header.vue";
import SiteNavigation from "@/components/layout/Navigation.vue";
import SiteFooter from "@/components/layout/Footer.vue";
import Request from "@/utils/request";
export default {
  name: "Home",
  components: {
    SiteHeader,
    SiteNavigation,
    SiteFooter,
  },
  data() {
    return {
      bannerList: [],
      hotList: [],
      newsList: [],
      noticeList: [],
      projectList: [],
    };
  },
  mounted() {
    this.getBanner();
    this.getHot();
    this.getNewsList();
    this.getNoticeList();
    this.getProjectList();
  },
  methods: {
    getBanner() {
      Request.get("/cms-web/banner/list/academy_banner").then((res) => {
        this.bannerList = res?.rows || [];
      });
    },
    getHot() {
      Request.get("/cms-web/article/list/hot/academy?limit=10").then((res) => {
        this.hotList = res || [];
      });
    },
    getNewsList() {
      Request.get(
        "/cms-web/article/list/top/academy_news_information?limit=7"
      ).then((res) => {
        this.newsList = res || [];
      });
    },
    getNoticeList() {
      Request.get(
        "/cms-web/article/list/top/academy_news_communication?limit=7"
      ).then((res) => {
        this.noticeList = res || [];
      });
    },
    getProjectList() {
      Request.get(
        "/cms-web/article/list/academy_innovation_project?top=Y"
      ).then((res) => {
        this.projectList = res?.rows || [];
        this.projectList = this.projectList.map((d) => {
          const currentDate = new Date(d.displayDate);
          return {
            ...d,
            displayM: `${currentDate.getFullYear()}-${
              currentDate.getMonth() + 1
            }`,
            displayD: currentDate.getDate(),
          };
        });
      });
    },
    jump(item) {
      this.$router.push(`/article/${item.id}`);
    },
    jumpUrl(item) {
      item.url && item.url !== "#" && window.open(item.url);
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .banner {
    margin-bottom: 40px;

    .banner-item {
      height: 100%;
      cursor: pointer;
      img {
        // width: 100%;
      }
    }
  }
  .main-content {
    flex: 1;
    width: 1200px;
    margin: 0 auto;
    padding: 20px;

    .news-showcase {
      display: flex;
      gap: 20px;
      margin-bottom: 40px;

      .news-carousel {
        width: 600px;
        cursor: pointer;
        .carousel-item {
          position: relative;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .carousel-content {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 20px;
            background: rgba(0, 0, 0, 0.5);
            color: white;

            h3 {
              margin: 0 0 10px;
              font-size: 18px;
              font-weight: bold;
            }

            p {
              margin: 0;
              font-size: 15px;
            }
          }
        }
      }

      .news-tabs {
        width: 550px;
        margin-left: 40px;
        :deep .el-tabs__item {
          color: #193d65;
          font-size: 24px;
          font-weight: bold;
        }
        :deep .el-tabs__nav-wrap::after {
          display: none;
        }
        :deep .el-tabs__active-bar {
          background-color: #193d65;
          height: 3px;
        }
        :deep .el-tabs__content {
          overflow: inherit;
        }
        .news-more {
          position: absolute;
          font-size: 14px;
          background: #193d65;
          padding: 6px 18px;
          border-radius: 20px;
          color: #fff;
          right: 10px;
          top: -50px;
          cursor: pointer;
          &:hover {
            background: #4da33a;
            color: #fff;
          }
        }
        .news-list-tab {
          list-style: none;
          padding: 0;
          margin: 0;
          font-size: 16px;
          li {
            display: flex;
            justify-content: space-between;
            padding: 11px 0;
            border-bottom: 1px solid #eee;
            position: relative;
            padding-right: 120px;
            .news-title {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              &:hover {
                color: #1890ff;
                cursor: pointer;
              }
            }

            .news-date {
              position: absolute;
              right: 0;
            }
          }
        }
      }
    }

    .news-section {
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        h2 {
          font-size: 24px;
          color: #333;
        }

        .more-link {
          font-size: 14px;
          background: #193d65;
          padding: 6px 18px;
          border-radius: 20px;
          color: #fff;
          right: 10px;
          top: -50px;
          cursor: pointer;
          &:hover {
            background: #4da33a;
            color: #fff;
          }
        }
      }

      .news-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;

        .news-item {
          display: flex;
          padding: 20px;
          background: #f5f5f5;
          border-radius: 4px;

          .news-date {
            padding: 10px 20px;
            text-align: center;
            border-right: 1px solid #ddd;

            .day {
              display: block;
              font-size: 24px;
              font-weight: bold;
              color: #333;
            }

            .month {
              display: block;
              color: #666;
              margin-top: 5px;
            }
          }

          .news-info {
            flex: 1;
            padding-left: 20px;

            h3 {
              font-size: 16px;
              margin-bottom: 10px;

              &:hover {
                color: #1890ff;
                cursor: pointer;
              }
            }

            p {
              color: #666;
              font-size: 14px;
              line-height: 1.5;
            }
          }
        }
      }
    }
  }
}
</style>
